// @ts-nocheck
// Fetch single
export const FETCH_CONTRACTOR_RATING_REQUEST =
  "FETCH_CONTRACTOR_RATING_REQUEST";
export const FETCH_CONTRACTOR_RATING_SUCCESS =
  "FETCH_CONTRACTOR_RATING_SUCCESS";
export const FETCH_CONTRACTOR_RATING_FAILURE =
  "FETCH_CONTRACTOR_RATING_FAILURE";

// Batch fetch
export const FETCH_CONTRACTOR_RATINGS_BATCH_REQUEST =
  "FETCH_CONTRACTOR_RATINGS_BATCH_REQUEST";
export const FETCH_CONTRACTOR_RATINGS_BATCH_SUCCESS =
  "FETCH_CONTRACTOR_RATINGS_BATCH_SUCCESS";
export const FETCH_CONTRACTOR_RATINGS_BATCH_FAILURE =
  "FETCH_CONTRACTOR_RATINGS_BATCH_FAILURE";

// Upsert
export const UPSERT_CONTRACTOR_RATING_REQUEST =
  "UPSERT_CONTRACTOR_RATING_REQUEST";
export const UPSERT_CONTRACTOR_RATING_SUCCESS =
  "UPSERT_CONTRACTOR_RATING_SUCCESS";
export const UPSERT_CONTRACTOR_RATING_FAILURE =
  "UPSERT_CONTRACTOR_RATING_FAILURE";

// Notes (add / remove). Every one of these responses carries the WHOLE rating
// document back, so the reducer replaces the entry instead of patching the
// array — no client-side reordering that could disagree with the server.
export const ADD_CONTRACTOR_RATING_NOTE_REQUEST =
  "ADD_CONTRACTOR_RATING_NOTE_REQUEST";
export const ADD_CONTRACTOR_RATING_NOTE_SUCCESS =
  "ADD_CONTRACTOR_RATING_NOTE_SUCCESS";
export const ADD_CONTRACTOR_RATING_NOTE_FAILURE =
  "ADD_CONTRACTOR_RATING_NOTE_FAILURE";

export const REMOVE_CONTRACTOR_RATING_NOTE_REQUEST =
  "REMOVE_CONTRACTOR_RATING_NOTE_REQUEST";
export const REMOVE_CONTRACTOR_RATING_NOTE_SUCCESS =
  "REMOVE_CONTRACTOR_RATING_NOTE_SUCCESS";
export const REMOVE_CONTRACTOR_RATING_NOTE_FAILURE =
  "REMOVE_CONTRACTOR_RATING_NOTE_FAILURE";
